/* eslint-disable */
import * as React from 'react';
import {QueryProvider} from '@thd-nucleus/data-sources';
import {useLocation, useParams} from '@thd-olt-component-react/router';
import {AppContext} from "@thd-nucleus/app-render";
import { SiteMapPage } from "../contentful/components/siteMap/SiteMapPage";

export const SiteMapContainer = () => {
  const {search: querystring, pathname} = useLocation();
  const pathWithQueryParams = `${pathname}${querystring}`;

  const {instance} = React.useContext(AppContext);
  let customerType = instance?.customer?.type;
  const previewLink = instance?.headers?.['x-content-preview'] !== undefined
    || pathWithQueryParams.includes('contentPV')
    || pathWithQueryParams.includes('render*')
    || pathWithQueryParams.includes('bassPV');

  const pageId = () =>{
    const params = pathname.split('/');
    return params[params.length - 1];
  };
  let slug = pageId();
  // This is specific for being able to render pages for Contentful's previews
  if (previewLink && (pageId().endsWith('-b2c') || pageId().endsWith('-b2b'))) {
    customerType = pageId().slice(-3);
    slug = pageId().replace(/-b2[b|c]$/, '');
  }

  return (
    <QueryProvider cacheKey="sc-sitemap-page">
      <SiteMapPage
        customerType={customerType}
        slug={slug}
        pathWithQueryParams={pathWithQueryParams}
        previewLink={previewLink} />
    </QueryProvider>
  )

};

SiteMapContainer.displayName = 'SiteMapContainer';
SiteMapContainer.prototype = {};
